import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { reactPlugin } from '@datadog/browser-rum-react';

export const initDatadogRum = (datadogConfig = {}) => {
    const { DD_APPLICATION_ID, DD_CLIENT_TOKEN, DD_SITE, DD_ENV } = datadogConfig;

    if (!DD_APPLICATION_ID || !DD_CLIENT_TOKEN || !DD_ENV || DD_APPLICATION_ID.startsWith('{{')) {
        return;
    }

    datadogRum.init({
        applicationId: DD_APPLICATION_ID,
        clientToken: DD_CLIENT_TOKEN,
        site: DD_SITE || 'datadoghq.com',
        service: 'customer-engage',
        env: DD_ENV,
        version: '2024.2.0',

        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,

        trackResources: true,
        trackUserInteractions: true,
        trackLongTasks: true,

        plugins: [reactPlugin({ router: false })],
    });

    datadogLogs.init({
        clientToken: DD_CLIENT_TOKEN,
        site: DD_SITE || 'datadoghq.com',
        service: 'customer-engage',
        env: DD_ENV,
        forwardErrorsToLogs: true,
    });
};

export const logger = datadogLogs.logger;
